import {Route} from '@angular/router';
import {MainLayoutComponent} from './layout/app-layout/main-layout/main-layout.component';
import {Page404Component} from './auth/page404/page404.component';
import {authGuard} from "./auth/auth.guard";
import {signInGuard} from "./auth/sign-in/sign-in.guard";
import {AuthComponent} from "./auth/auth.component";

export const APP_ROUTE: Route[] = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {path: '', redirectTo: '/auth/sign-in', pathMatch: 'full'},
      {
        path: 'organisation',
        loadChildren: () =>
          import('./organisation/organisation.routes').then((m) => m.ORGANISATION_ROUTE),
      },
      {
        path: 'billing',
        loadChildren: () =>
          import('./billing/billing.routes').then((m) => m.BILLING_ROUTE),
      },
      {
        path: 'engineering',
        loadChildren: () =>
          import('./engineering/engineering.routes').then((m) => m.ENGINEERING_ROUTE),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./admin/admin.routes').then((m) => m.ADMIN_ROUTE),
      },
      {
        path: 'template',
        loadChildren: () =>
          import('./shared/components/advance-table/advance-table.routes').then((m) => m.ADVANCE_TABLE_ROUTE),
      },
    ],
  },
  {
    path: 'auth',
    component: AuthComponent,
    loadChildren: () =>
      import('./auth/auth.routes').then((m) => m.AUTH_ROUTE),
    canActivate: [signInGuard]
  },
  {
    path: '**',
    component: Page404Component
  }
];
